<template>
  <footer v-bind:class="classes">
    <div class="container">
      <div class="row">
          <div :class="colClasses">
            <ul class="nav font-weight-light" :class="navClasses">
              <li class="nav-item">
                <a href="#" class="nav-link" target="_blank">About Us</a>
              </li>
              <li class="nav-item">
                <span class="nav-link text-secondary">|</span>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" target="_blank">Privacy Policy</a>
              </li>
              <li class="nav-item">
                <span class="nav-link text-secondary">|</span>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" target="_blank">Terms & Conditions</a>
              </li>
            </ul>
          </div>
          <!-- <div :class="colClasses">
            <div class="mt-2 copyright text-secondary" :class="copyrightClasses">
              MYLE, LLC © {{year}}
            </div>
          </div> -->
        </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'base-footer',
    props: {
      classes: {
        type: String,
        default: '',
        description: 'Footer classes'
      },
      colClasses: {
        type: String,
        default: 'col-md-6',
        description: 'Footer column classes'
      },
      navClasses: {
        type: String,
        default: '',
        description: 'Footer nav classes'
      },
      copyrightClasses: {
        type: String,
        default: '',
        description: 'Footer copyright classes'
      }
    },
    data() {
      return {
        year: new Date().getFullYear(),
        isCol: this.type == 'cols'
      }
    },
  }
</script>
<style>
 .nav-item {
  color: #209A75;
 }
</style>
